import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'atsInterviews';

const initialState = {
  notes: { data: [], meta: {} },
};

const { reducer, actions: atsInterviewActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    addInterviewNotes: (state, { payload }) => {
      const { notes = [], meta = null, isInitial = false } = payload;
      if (isInitial) {
        state.notes.data = [...notes]?.reverse();
        state.notes.meta = meta;
      } else {
        state.notes.data = [...[...notes]?.reverse(), ...state?.notes?.data];
        state.notes.meta = meta;
      }
    },

    addInterviewNote: (state, { payload }) => {
      const { newNote } = payload;
      state.notes.data =
        state?.notes?.data?.length > 0
          ? [...state?.notes?.data, newNote]
          : [newNote];
      state.notes.meta = {
        ...state.notes.meta,
        count: (state?.notes?.meta?.count || 0) + 1,
      };
    },

    updateInterviewNote: (state, { payload }) => {
      const { note, newNote } = payload;
      state.notes.data = state?.notes?.data?.map?.((item) => {
        if (item?.id === note?.id) return newNote;
        else return item;
      });
    },
  },
});

export { atsInterviewActions };
export default reducer;
